/**
 * 堂食就餐人数选择
 */
import React from 'react'
import { parse } from 'qs'
import { observer } from 'mobx-react'
import { IonModal, IonHeader, IonContent } from '@ionic/react'
import { checkoutMobx } from '@mobxStore'
import { store } from '@dt/fe-utils'
import { miniAppRouteTo } from '@utils'
import './index.scss'

interface IProps {
  config: IDiningNumConfig;
  reject?: (err: any) => void;
  resolve?: () => void;
}

const RegisterGuide: React.FC<IProps> = ({ reject, resolve, config }) => {
  const brandInfo = store.get(`ls.brandInfo.${Config.BRANDID}`)
  // 关闭弹层
  const handleClose = () => {
    reject('close')
  }
  // 暂时不加入会员
  const handleIgnore = () => {
    checkoutMobx.setGuideRegister(false)
    reject('close')
  }
  // 确认选择
  const handleConfirm = () => {
    const searchParams = parse(location.search.replace('?', ''))
    miniAppRouteTo(`/pages/authPhone/index?jumpH5Page=${location.origin + location.pathname}&originInfo=${JSON.stringify(searchParams)}`)
    resolve()
  }
  return (
    <IonModal
      isOpen
      swipeToClose
      cssClass='guide-register-modal'
    >
      <IonHeader>
        <div className='header'>
          <i className='header-close iconfont icon-close' onClick={handleClose} />
        </div>
      </IonHeader>
      <IonContent>
        <div className='guide-register-container'>
          <div className='title'>{i18n.t('cart.joinTips1', { brandName: brandInfo?.brandName || '' })}</div>
          <div className='tips'>{i18n.t('cart.joinTips2')}</div>
          <div className='register-btn' onClick={handleConfirm}>{i18n.t('cart.phoneJoin')}</div>
          <div className='reject-btn' onClick={handleIgnore}>{i18n.t('cart.rejectJoin')}</div>
        </div>
      </IonContent>
    </IonModal>
  )
}

export default observer(RegisterGuide)
